<template>
  <div>
    <div class="container">
      <div class="row">
        <!-- Kolom kiri -->
        <div class="col-12 col-lg-8">
          <!-- Kotak atas: Total Nasabah -->
          <div class="mb-3">
            <b-card
              border-variant="primary"
              header="Total Nasabah"
              class="custom-card-header"
              align="center"
            >
              <template v-if="!isLoading">
                <h4>{{ total_nasabah }}</h4>
              </template>
              <template v-else>
                <h4><b-spinner variant="warning"></b-spinner></h4>
              </template>
            </b-card>
          </div>

          <!-- Kotak bawah kiri-kanan -->
          <div class="row">
            <div class="col-12 col-md-6">
              <b-card
                border-variant="primary"
                header="Total Nasabah Yang Mengajukan"
                class="custom-card-header h-100"
                align="center"
              >
                <template v-if="!isLoading">
                  <h4>{{ total_nasabah_pengajuan }}</h4>
                </template>
                <template v-else>
                  <h4><b-spinner variant="warning"></b-spinner></h4>
                </template>
              </b-card>
            </div>
            <div class="col-12 col-md-6">
              <b-card
                border-variant="primary"
                header="Total Nasabah Yang Tidak Mengajukan"
                class="custom-card-header h-100"
                align="center"
              >
                <template v-if="!isLoading">
                  <h4>{{ total_nasabah_tanpa_pengajuan }}</h4>
                </template>
                <template v-else>
                  <h4><b-spinner variant="warning"></b-spinner></h4>
                </template>
              </b-card>
            </div>
          </div>
        </div>

        <!-- Kolom kanan -->
        <div class="col-12 col-lg-4 d-flex">
          <b-card
            border-variant="primary"
            header="Top Nasabah"
            class="custom-card-header flex-fill"
            align="center"
          >
            <template v-if="!isLoading">
              <template v-if="nasabah_populer && nasabah_populer.length > 0">
                <div
                  v-for="(nasabah, index) in nasabah_populer"
                  :key="index"
                  class="nasabah-item"
                >
                  {{ nasabah.funder_name }}
                  <hr v-if="index !== nasabah_populer.length - 1" class="my-2 border-gray-300" />
                </div>
              </template>
              <template v-else>
                <div
                  class="p-3 text-center text-muted"
                  style="font-size: 18px; font-weight: 500"
                >
                  Belum ada
                </div>
              </template>
            </template>
            <template v-else>
              <div class="p-3"><b-spinner variant="warning"></b-spinner></div>
            </template>
          </b-card>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Kolom kiri -->
        <div class="col-12 col-lg-8">
          <!-- Kotak atas: Total Pengajuan -->
          <div class="mb-3">
            <b-card
              border-variant="primary"
              header="Total Pengajuan"
              class="custom-card-header"
              align="center"
            >
              <template v-if="!isLoading">
                <h4>{{ total_pengajuan }}</h4>
              </template>
              <template v-else>
                <h4><b-spinner variant="warning"></b-spinner></h4>
              </template>
            </b-card>
          </div>

          <!-- Kotak bawah kiri-kanan -->
          <div class="row">
            <div class="col-12 col-md-6">
              <b-card
                border-variant="primary"
                header="Total Pengajuan Yang Disetujui"
                class="custom-card-header h-100"
                align="center"
              >
                <template v-if="!isLoading">
                  <h4>{{ total_pengajuan_approved }}</h4>
                </template>
                <template v-else>
                  <h4><b-spinner variant="warning"></b-spinner></h4>
                </template>
              </b-card>
            </div>

            <div class="col-12 col-md-6">
              <b-card
                border-variant="primary"
                header="Total Pengajuan Yang Tidak Disetujui"
                class="custom-card-header h-100"
                align="center"
              >
                <template v-if="!isLoading">
                  <h4>{{ total_pengajuan_not_approved }}</h4>
                </template>
                <template v-else>
                  <h4><b-spinner variant="warning"></b-spinner></h4>
                </template>
              </b-card>
            </div>
          </div>
        </div>

        <!-- Kolom kanan -->
        <div class="col-12 col-lg-4 d-flex">
          <b-card
            border-variant="primary"
            header="Produk Populer"
            class="custom-card-header flex-fill"
            align="center"
          >
            <template v-if="produk_populer && produk_populer.length > 0">
              <div
                v-for="(produk, index) in produk_populer"
                :key="index"
                class="nasabah-item"
              >
                {{ produk.product_name }}

                <hr v-if="index !== produk_populer.length - 1" class="my-2 border-gray-300" />
              </div>
            </template>
            <template v-else>
              <div
                class="p-3 text-center text-muted"
                style="font-size: 18px; font-weight: 500"
              >
                Belum ada
              </div>
            </template>
            <template v-else>
              <h4><b-spinner variant="warning"></b-spinner></h4>
            </template>
          </b-card>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-md-12 mb-3">
          <b-card
            border-variant="primary"
            header="Total Ujrah"
            class="custom-card-header"
            align="center"
          >
            <template v-if="!isLoading">
              <h4>Rp.{{ new Intl.NumberFormat().format(total_fee) }}</h4>
            </template>
            <template v-else>
              <h4><b-spinner variant="warning"></b-spinner></h4>
            </template>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingAgency from "../../api/marketingAgency.js";

export default {
  name: "DashboardMitra",
  data() {
    return {
      isLoading: false,
      total_fee: 0,
      total_pengajuan: 0,
      total_nasabah_pengajuan: 0,
      total_nasabah: 0,
      total_nasabah_tanpa_pengajuan: 0,
      total_pengajuan: 0,
      produk_populer: [],
      nasabah_populer: [],
      total_pengajuan_approved: 0,
      total_pengajuan_not_approved: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;
      MarketingAgency.statistic()
        .then((response) => {
          this.total_nasabah = response.data.data.total_users
            ? response.data.data.total_users
            : 0;
          this.total_fee = response.data.data.total_fee
            ? response.data.data.total_fee
            : 0;
          this.total_pengajuan = response.data.data.total_pengajuan
            ? response.data.data.total_pengajuan
            : 0;
          this.total_nasabah_pengajuan = response.data.data.users_with_pengajuan
            ? response.data.data.users_with_pengajuan
            : 0;
          this.total_nasabah_tanpa_pengajuan = response.data.data
            .users_without_pengajuan
            ? response.data.data.users_without_pengajuan
            : 0;
          this.produk_populer = response.data.data.produk_populer
            ? response.data.data.produk_populer
            : [];
          this.nasabah_populer = response.data.data.top_nasabah
            ? response.data.data.top_nasabah
            : [];
          this.total_pengajuan_approved = response.data.data.pengajuan_approved
            ? response.data.data.pengajuan_approved
            : 0;
          this.total_pengajuan_not_approved = response.data.data
            .pengajuan_not_approved
            ? response.data.data.pengajuan_not_approved
            : 0;
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.custom-card-header .card-header {
  background-color: #274c8f;
  color: #f6bc3c;
}

/* Semua tulisan di dalam card */
.custom-card-header .card-body {
  color: #0b42a8; /* biru */
}

.nasabah-item,
.produk-item {
  color: #0b42a8;
}
.nasabah-item {
  position: relative;
  padding-left: 15px; /* kasih jarak supaya titik tidak nabrak teks */
  margin-bottom: 5px;
}

.nasabah-item::before {
  position: absolute;
  left: 0;
  color: #0b42a8; /* bisa diganti warna sesuai tema */
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard-agency-index.vue